import React, { useState } from 'react';

import Modal from 'components/cosmos/modal';
import { Loader } from 'components/loader';
import { I18n } from 'components/translate';
import { REASONS_BLOCK } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import FormReasonsBlock from './components/FormReasonsBlock';

import './UserReasonBlockModal.scss';

const UserReasonBlockModal = ({
  titlePlural = false,
  toggleModal,
  changeStatus,
  handleError,
  isOpen,
  setForm = null
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [reason, setReason] = useState('');
  const [otherReason, setOtherReason] = useState('');

  const { OTHERS } = REASONS_BLOCK;

  const isOtherReason = () => reason === OTHERS;

  const getFormValues = () => ({
    blockReason: reason,
    blockReasonDescription: isOtherReason() ? otherReason : ''
  });

  const handleClick = async () => {
    try {
      setShowLoader(true);

      const form = getFormValues();

      await changeStatus(form);
    } catch (error) {
      handleError(error);
    } finally {
      setShowLoader(false);
    }
  };

  const onChangeReason = (value) => {
    setReason(value);
    setForm && setForm({ blockReason: value, blockReasonDescription: '' });
  };

  const onChangeOtherText = (textOther) => {
    setOtherReason(textOther);
    setForm &&
      setForm({ blockReason: reason, blockReasonDescription: textOther });
  };

  const footer = showLoader ? (
    <Loader key="loader" />
  ) : (
    <>
      <button
        className="hot-button hot-button--primary hot-button--lg _mr-4"
        disabled={!reason}
        onClick={handleClick}
      >
        <I18n label="general.block" />
      </button>
      <button
        className="hot-button hot-button--secondary hot-button--lg"
        onClick={toggleModal}
      >
        <I18n label="general.cancel" />
      </button>
    </>
  );

  const header = (
    <h4 className="_font-weight-bold" data-test="user-block-modal-title">
      <I18n label="general.warn_title" />
    </h4>
  );

  return (
    <Modal
      header={header}
      footer={footer}
      open={isOpen}
      onClose={toggleModal}
      className="user-reason-block-modal"
    >
      <h6 className="_font-weight-bold">
        {!titlePlural ? (
          <I18n label="users_manager.deep_search.access.modal_reason_block.title" />
        ) : (
          <I18n label="users_manager.deep_search.access.modal_reason_block.title_plural" />
        )}
      </h6>

      <p data-test="user-block-modal-description">
        <I18n label="users_manager.deep_search.access.modal_reason_block.description" />
      </p>

      <FormReasonsBlock
        onChangeReason={onChangeReason}
        onChangeOtherText={onChangeOtherText}
      />
    </Modal>
  );
};

UserReasonBlockModal.propTypes = {
  titlePlural: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setForm: PropTypes.any
};

export default UserReasonBlockModal;
